import React from 'react'
import styled from '@emotion/styled'
import { useInView } from 'react-cool-inview'
import { navigate } from 'gatsby'

import getVar from '../utils/getVar'


const ObserverHelperTop = styled('div')`
  position: absolute;
  top: var(--real99_5vh);
  height: 200px;
  width: 11px;
  pointer-events: none;
  z-index: 1000;
`

const ObserverTop = ({title, id, setCurrentProject, isFirst, setHideStatusContainer, setFieldNotes, fieldNotes}) => {
  //const real99_5vh  = getVar('--real99_5vh')
  //const real90vh    = getVar('--real90vh')

  // console.log(`99.5vh: ${real99_5vh}`)
  // console.log(`90vh: ${real90vh}`)



  

  const { observe, inView, scrollDirection, entry } = useInView(
    {
      threshold: [0, 0.2, 0.4, 0.6, 0.8, 1],
      trackVisibility: true,
      // Set a minimum delay between notifications, it must be set to 100 (ms) or greater
      // For performance perspective, use the largest tolerable value as much as possible
      delay: 100,

      onEnter: ({ scrollDirection, entry  }) => {
        console.log(id)
        if (typeof window !== 'undefined') {
          // window.history.replaceState({}, '', id);
          window.history.replaceState(null,  null, `${window.location.origin}/${id}`);
          
        }

        // console.log(title)

        // Triggered when the target enters the viewport
        setCurrentProject(title)
        scrollDirection.vertical === 'up' && isFirst ? setHideStatusContainer(false) : null

        if(scrollDirection.vertical === 'up') {
          fieldNotes ? setFieldNotes(fieldNotes) : setFieldNotes(null)
        }
      },
      onLeave: ({ scrollDirection, entry }) => {
        // Triggered when the target leaves the viewport
        // console.log('top leaving')
        setTimeout(() => {
          // scrollDirection.vertical === 'down' && isFirst ? setCurrentProject(null) : null
        }, 250)
        
        scrollDirection.vertical === 'down' && isFirst ? setHideStatusContainer(true) : setHideStatusContainer(false)
        scrollDirection.vertical === 'down' && isFirst ? window.history.replaceState({}, '', '/') : null
      },
    }
  )

    // console.log(ref)

  return (
    <ObserverHelperTop 
      ref={observe} 
      isFirst={isFirst}
      //real99_5vh={real99_5vh}
      //real90vh={real90vh}
      //style={{ 'margin-bottom': real99_5vh }}
    />
  )
}

export default ObserverTop